import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { Button } from 'foundations-components/transitional/components/Button';
import { LeftIcon } from 'foundations-assets/icons/components/LeftIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function MobilePanelHeaderButton(props) {
  return /*#__PURE__*/_jsx(Button, Object.assign({}, props, {
    use: "transparent"
  }));
}
export function MobilePanelHeaderLeftButton(props) {
  return /*#__PURE__*/_jsx(MobilePanelHeaderButton, Object.assign({}, props, {
    padding: "400",
    marginInlineStart: "200"
  }));
}
export function MobilePanelHeaderRightButton(props) {
  return /*#__PURE__*/_jsx(MobilePanelHeaderButton, Object.assign({}, props, {
    padding: "400",
    marginInlineEnd: "200"
  }));
}
export function MobilePanelHeaderBackButton(_ref) {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(MobilePanelHeaderLeftButton, Object.assign({}, rest, {
    children: [/*#__PURE__*/_jsx(LeftIcon, {
      color: "fill-info-default",
      size: "600"
    }), children]
  }));
}